module.exports = {
  description: 'generate new Base/Variant component',
  prompts: [
    {
      type: 'input',
      name: 'baseName',
      message: 'base name please'
    },
    {
      type: 'input',
      name: 'variantName',
      message: 'variant name please'
    },
  ],
  actions: (): import('plop').ActionType[] => {
    const rootTemplatePath = 'app/javascript/components/plop/templates/base-variant-component';
    const rootDestinationPath = 'app/javascript/components/library/{{kebabCase baseName}}';

    const actions = [
      {
        destination: rootDestinationPath,
        base: rootTemplatePath,
        templateFiles: [
          `${rootTemplatePath}/__tests__/*.hbs`,
          `${rootTemplatePath}/*.hbs`,
        ]
      },
      {
        destination: `${rootDestinationPath}/{{kebabCase variantName}}`,
        base: `${rootTemplatePath}/variant-files`,
        templateFiles: `${rootTemplatePath}/variant-files/*.hbs`,
      },
      {
        destination: `${rootDestinationPath}/base`,
        base: `${rootTemplatePath}/base-files`,
        templateFiles: `${rootTemplatePath}/base-files/*.hbs`,
      },
      {
        destination: `${rootDestinationPath}/stories`,
        base: `${rootTemplatePath}/stories-files`,
        templateFiles: `${rootTemplatePath}/stories-files/*.hbs`,
      },
    ];

    return actions.map(({ base, destination, templateFiles }) => ({
      type: 'addMany',
      destination,
      base,
      templateFiles,
    }));
  },
};
